module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPrize) ? _c('div', {
    staticClass: "fullPage"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("../../assets/img/team/close.png")
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("我的礼包")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("（一共获得了" + _vm._s(_vm.num) + "个礼包）")]), _vm._v(" "), _c('ul', {
    staticClass: "space"
  }, _vm._l((_vm.prizeList), function(item, index) {
    return _c('li', {
      staticClass: "list"
    }, [_c('p', {
      staticClass: "awardsTime"
    }, [_vm._v(_vm._s(_vm.awardsTime[index]))]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.viewed == 0),
        expression: "item.viewed == 0"
      }],
      ref: "items",
      refInFor: true,
      staticClass: "treasure",
      attrs: {
        "src": require("../../assets/img/team/treasure.png")
      },
      on: {
        "click": function($event) {
          _vm.touchPrize(index)
        }
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.viewed == 1),
        expression: "item.viewed == 1"
      }],
      ref: "cards",
      refInFor: true,
      class: item.className,
      attrs: {
        "src": item.img
      }
    })])
  })), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.exchange()
      }
    }
  }, [_vm._v("兑换礼包中的奖品")])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6413b8ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6413b8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/prize.vue
// module id = 390
// module chunks = 6